import { render, staticRenderFns } from "./aiMateTrans.vue?vue&type=template&id=57a85543&"
import script from "./aiMateTrans.vue?vue&type=script&lang=js&"
export * from "./aiMateTrans.vue?vue&type=script&lang=js&"
import style0 from "./aiMateTrans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports